import http from '../../utils/fetch';
export default {
    insert(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/insert',
            method: 'post',
            data: query
        });
    },

    query(v) {
        return http({
            url: '/api/swyl/v1/test/ViewUserSupplierController/selectPage',
            method: 'post',
            params: v
        });
    },
    queryshanghai(v) {
        return http({
            url: '/api/swyl/v1/test/ViewUserSupplierController/selectShangHaiPage',
            method: 'post',
            params: v
        });
    },
    queryOne(v) {
        return http({
            url: '/api/swyl/v1/test/ViewUserSupplierController/selectOne',
            method: 'post',
            params: v
        });
    },
    updateDetail(v) {
        return http({
            url: '/api/swyl/v1/test/ViewUserSupplierController/updateDetail',
            method: 'post',
            params: v
        });
    },
    update(v) {
        return http({
            url: '/api/swyl/v1/test/ViewUserSupplierController/selectOne',
            method: 'post',
            params: v
        });
    },
    check(v) {
        return http({
            url: '/api/swyl/v1/test/ViewUserSupplierController/selectPage',
            method: 'post',
            params: v
        });
    },
    checkShangHai(v) {
        return http({
            url: '/api/swyl/v1/test/ViewUserSupplierController/selectShangHaiPage',
            method: 'post',
            params: v
        });
    },
    selectHistoryPage(v) {
        return http({
            url: '/api/swyl/v1/supplier/supplierOperate/selectPage',
            method: 'post',
            params: v
        });
    },

    getMdmSupplyBank(query){
        return http({
            url: '/api/swyl/v1/test/bscUserInfoSupplierCopy/getMdmSupplyBank',
            method: 'post',
            data:query
        });
    },
    getMdmSupplyCompany(query){
        return http({
            url: '/api/swyl/v1/test/bscUserInfoSupplierCopy/getMdmSupplyCompany',
            method: 'post',
            data:query
        });
    },
    getMdmSupplyPur(query){
        return http({
            url: '/api/swyl/v1/test/bscUserInfoSupplierCopy/getMdmSupplyPur',
            method: 'post',
            data:query
        });
    },
    getMdmSupply(query){
        return http({
            url: '/api/swyl/v1/test/bscUserInfoSupplierCopy/getMdmSupply',
            method: 'post',
            data:query
        });
    },
    insertBscUserInfoSupplier(param){
        return http({
            url: '/api/swyl/v1/test/bscUserInfoSupplierCopy/insertBscUserInfoSupplier',
            method: 'post',
            data: param
        });
    },
}